import { render } from "./WcSearchForm.vue?vue&type=template&id=6575963b&scoped=true"
import script from "./WcSearchForm.vue?vue&type=script&lang=js"
export * from "./WcSearchForm.vue?vue&type=script&lang=js"

import "./WcSearchForm.vue?vue&type=style&index=0&id=6575963b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6575963b"]])

export default __exports__